const POLICY_CHAR_LENGTH = 'charLength';
const POLICY_LOWERCASE = 'lowercase';
const POLICY_UPPERCASE = 'uppercase';
const POLICY_SPECIAL = 'special';
const POLICY_INTEGER = 'integer';

export const rules = [
    POLICY_CHAR_LENGTH,
    POLICY_LOWERCASE,
    POLICY_UPPERCASE,
    POLICY_SPECIAL,
    POLICY_INTEGER,
];

export const titles = {
    [POLICY_CHAR_LENGTH]: 'At least 8 characters',
    [POLICY_LOWERCASE]: 'At least 1 lowercase character',
    [POLICY_UPPERCASE]: 'At least 1 uppercase character',
    [POLICY_SPECIAL]: 'At least 1 special character',
    [POLICY_INTEGER]: 'At least 1 number',
};

export const validators = {
    [POLICY_CHAR_LENGTH]: function(value) {
        if( value.length >= 8 ) {
            return true;
        }

        return false;
    },
    [POLICY_LOWERCASE]: function(value) {
        var regex = /^(?=.*[a-z]).+$/;

        if( regex.test(value) ) {
            return true;
        }

        return false;
    },
    [POLICY_UPPERCASE]: function(value) {
        var regex = /^(?=.*[A-Z]).+$/;

        if( regex.test(value) ) {
            return true;
        }

        return false;
    },
    [POLICY_SPECIAL]: function(value) {
        // @see https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-policies.html
        // ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~
        const special_characters = "^$*.[]{}()?-\"!@#%&/\\,><':;|_~";
        
        for (var i = 0; i < special_characters.length;i++){
            if (value.indexOf(special_characters[i]) > -1){
                return true;
            }
        }
        
        return false;
    },
    [POLICY_INTEGER]: function(value) {
        var regex = /[0-9]/;

        if( regex.test(value) ) {
            return true;
        }

        return false;
    }
};


export default {
    rules,
    titles,
    validators,
}